import { mqLaptop, mqTabletPortrait, mqPhone } from '../../utils/mq';

document.addEventListener('alpine:init', () => {
  Alpine.data('countriesFilterable', () => ({
    get shown() {
      return this._shown;
    },
    set shown(value) {
      if (!this._firstTimeShown && history.state?.restoreScrollPosition) {
        if (history.state?.activeRegionName) {
          this.$root.querySelector(`button[data-region-name="${history.state.activeRegionName}"]`)?.click();
        }

        this.$nextTick(() => {
          this.pushAndFilter(history.state?.page ?? 1, false, false);
          this.$nextTick(() => this.$refs.results.scrollIntoView());
        });
      }

      this._shown = value;
      this._firstTimeShown = true;
    },
    _shown: false,
    _firstTimeShown: false,

    items: [],

    filteredItems: [],

    keywords: history.state?.restoreScrollPosition ? history.state.keywords : '',

    regions: [],

    activeRegionName: 'all',

    page: 1,

    perPage: 0,

    lastPage: 0,

    count: 0,

    pagination: [],

    init() {
      if (mqPhone.matches) {
        this.perPage = 6;
      } else if (mqTabletPortrait.matches) {
        this.perPage = 8;
      } else if (mqLaptop.matches) {
        this.perPage = 12;
      } else {
        this.perPage = 12;
      }

      this.items = [
        ...this.$root.querySelectorAll(
          '.countries-filterable__results-items--static .countries-filterable__results-item'
        ),
      ].map((el) => ({
        id: el.dataset.id,
        name: el.dataset.name,
        image: el.dataset.image,
        link: el.href,
        region: +el.dataset.region,
        marketSize: +el.dataset.marketSize.trim().replace(/[^0-9\.]/g, ''),
      }));

      this.items.sort((a, b) => b.marketSize - a.marketSize);

      this.regions = this.$root.dataset.regions.split(',').map((r) => +r);

      this.filter();
    },

    filter(page, scrollIntoView = false) {
      if (page && !this.shown) {
        return;
      }

      const results = this.items.filter((item) => {
        if (!this.regions.includes(item.region)) {
          return false;
        }

        if (this.keywords.trim() && !item.name.toLowerCase().includes(this.keywords.trim().toLowerCase())) {
          return false;
        }

        return true;
      });

      this.count = results.length;
      this.lastPage = Math.ceil(this.count / this.perPage);
      this.page = page ? Math.min(this.lastPage, Math.max(1, page)) : 1;
      this.pagination = [];

      const paginationStart = Math.max(1, this.page - 2);
      const paginationEnd = Math.min(paginationStart + 4, this.lastPage);

      for (let i = paginationStart; i <= paginationEnd; i++) {
        this.pagination.push(i);
      }

      const missing = 5 - this.pagination.length;

      for (let i = 0; i < missing; i++) {
        if (paginationStart - i - 1 >= 1) {
          this.pagination.unshift(paginationStart - i - 1);
        }
      }

      this.filteredItems = results.slice((this.page - 1) * this.perPage, (this.page - 1) * this.perPage + this.perPage);

      if (scrollIntoView) {
        this.$nextTick(() => this.$refs.results.scrollIntoView());
      }
    },

    pushAndFilter(page, restoreScrollPosition = false, scrollIntoView = false) {
      this.push(page, restoreScrollPosition);
      this.filter(page, scrollIntoView);
    },

    push(page, restoreScrollPosition = false) {
      history.pushState(
        {
          activeRegionName: this.activeRegionName,
          keywords: this.keywords,
          page: page ?? 1,
          restoreScrollPosition,
        },
        null
      );
    },

    changeRegion(e, name, ids) {
      this.activeRegionName = name;
      this.regions = ids;

      if (e.isTrusted) {
        this.pushAndFilter();
      } else {
        this.filter();
      }
    },

    clearKeywords() {
      this.keywords = '';
      this.pushAndFilter();
    },

    onResultClick() {
      this.push(this.page, true);
    },
  }));
});